<div class="small-image-card -card-container">
  <cardBasic class="small-image-card -colorShadePrimaryBlack">
    <div class="small-image-card -image-container">      
      <img [src]="image" />      
    </div>
    <div class="small-image-card -card-details">
      <ng-content></ng-content>
    </div>
  </cardBasic>
</div>